import Model from "./base/model";

class ProcedaOccurrence extends Model{
  resourceName() {
    return "proceda_occurrences";
  }

  fields() {
    return {
      code:"",
      description:""
    };
  }
}

export default new ProcedaOccurrence();
